import React from 'react';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import PostinganTerbaruSection from '../components/PostinganTerbaruSection';
import ProgramStudiSection from '../components/ProgramStudiSection';
import ProgramUnggulanSection from '../components/ProgramUnggulanSection';
import CTASection from '../components/CTASection';

const Beranda = () => {
  return (
    <main>
      <Hero />
      <AboutSection />
      <PostinganTerbaruSection />
      <ProgramStudiSection />
      <ProgramUnggulanSection />
      <CTASection />
    </main>
  );
};

export default Beranda;
